import React, { useState } from "react";
import "../styles/navbar.css";
import { NavLink } from "react-router-dom";
import DropdownMenu from "../components/DropdownMenu";
import { useAuth } from "../providers/AuthContext";
import UserDropdown from "./userDropdown";


export default function Navbar({permissions}) {
  const {userEmail}  = useAuth()
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="w-full shadow-custom relative z-30">
      <div className="mx-auto my-0 px-[8px] max-w-[1400px]">
        <div className="flex items-center">
          {/* Logo */}
          <div className="h-12 p-2 mx-2 shrink-0">
            <img
              className="h-full w-auto max-w-full"
              alt="logo"
              src={`${process.env.PUBLIC_URL}/images/logos/sens.png`}
            />
          </div>

          {/* Menú de navegación (desktop) */}
          <ul className="hidden md:flex flex-wrap list-none relative p-0 m-0">
            {permissions.map(({ label, path, icon, items }) =>
              items.length > 0 ? (
                <DropdownMenu
                  key={label}
                  label={label}
                  icon={`${process.env.PUBLIC_URL}/svg/${icon}`}
                  options={items.map(({ label, path }) => ({
                    to: path,
                    label,
                  }))}
                />
              ) : (
                <NavLink
                  key={label}
                  to={path}
                  className={({ isActive }) =>
                    `flex gap-1 items-center px-6 py-3 cursor-pointer border-b-[2.5px] ${
                      isActive
                        ? "border-bluesens text-gray-700"
                        : "border-transparent text-gray-700"
                    }`
                  }
                >
                  {icon && (
                    <img
                      className="w-4 h-4"
                      alt={label}
                      src={`${process.env.PUBLIC_URL}/svg/${icon}`}
                    />
                  )}
                  {label}
                </NavLink>
              )
            )}
          </ul>

          {/* Espaciador */}
          <span className="hidden md:flex flex-row flex-1"></span>

          {/* Selector de idioma (desktop) */}
          <div className="hidden md:block mx-4">
            <select>
              <option> Español</option>
            </select>
          </div>

          {/* Perfil de usuario (desktop) */}
          <div className="hidden md:block">
            <UserDropdown userEmail={userEmail}/>
          </div>

          {/* Espaciador móvil + botón hamburguesa */}
          <span className="flex md:hidden flex-row flex-1"></span>
          <button
            className="md:hidden p-2 mx-1 text-bluesens focus:outline-none"
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label={mobileOpen ? "Cerrar menú" : "Abrir menú"}
          >
            {mobileOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="6" y1="6" x2="18" y2="18" />
                <line x1="6" y1="18" x2="18" y2="6" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Menú de navegación (móvil, desplegable) */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white shadow-md">
          <ul className="flex flex-col list-none p-0 m-0">
            {permissions.map(({ label, path, icon, items }) =>
              items.length > 0 ? (
                <DropdownMenu
                  key={label}
                  label={label}
                  icon={`${process.env.PUBLIC_URL}/svg/${icon}`}
                  options={items.map(({ label, path }) => ({
                    to: path,
                    label,
                  }))}
                />
              ) : (
                <NavLink
                  key={label}
                  to={path}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex gap-2 items-center px-6 py-3 cursor-pointer border-l-[3px] ${
                      isActive
                        ? "border-bluesens text-gray-700 bg-graysens"
                        : "border-transparent text-gray-700"
                    }`
                  }
                >
                  {icon && (
                    <img
                      className="w-4 h-4"
                      alt={label}
                      src={`${process.env.PUBLIC_URL}/svg/${icon}`}
                    />
                  )}
                  {label}
                </NavLink>
              )
            )}
          </ul>
          <div className="flex items-center justify-between px-6 py-3 border-t border-gray-200">
            <select>
              <option> Español</option>
            </select>
            <UserDropdown userEmail={userEmail}/>
          </div>
        </div>
      )}
    </div>
  );
}
